import { Card as CardANTD, Input, Button } from "antd";
import "./Card.css";

const Card = ({ content, isSelected, hidePrompt, onSelect, promptValue, onPromptChange, onRevise, revising }) => {
  return (
    <div className={`card-container ${isSelected ? "is-selected" : ""}`}>
      <CardANTD className="card" hoverable onClick={(e) => {
        e.stopPropagation();
        onSelect();
      }}>
        {content}
      </CardANTD>

      {!hidePrompt && (
        <div className="prompt-container" onClick={(e) => e.stopPropagation()}>
          <Input.TextArea
            className="prompt-textarea"
            value={promptValue}
            onChange={(e) => onPromptChange(e.target.value)}
            placeholder="Revise with instructions"
            autoSize={{ minRows: 1, maxRows: 3 }}
            disabled={revising}
          />
          <Button
            className="prompt-button"
            onClick={(e) => {
              e.stopPropagation();
              onRevise();
            }}
            loading={revising}
            disabled={!String(promptValue || "").trim()}
          >
            Revise with AI
          </Button>
        </div>
      )}
    </div>
  );
};


export default Card;
